var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Add component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconAdd extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7495 2.85492C12.7495 2.44071 12.4137 2.10492 11.9995 2.10492C11.5853 2.10492 11.2495 2.44071 11.2495 2.85492V11.1933H2.85449C2.44028 11.1933 2.10449 11.5291 2.10449 11.9433C2.10449 12.3575 2.44028 12.6933 2.85449 12.6933H11.2495V21.1449C11.2495 21.5591 11.5853 21.8949 11.9995 21.8949C12.4137 21.8949 12.7495 21.5591 12.7495 21.1449V12.6933H21.1445C21.5587 12.6933 21.8945 12.3575 21.8945 11.9433C21.8945 11.5291 21.5587 11.1933 21.1445 11.1933H12.7495V2.85492Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconAdd.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconAdd.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconAdd.prototype, "size", void 0);
if (customElements.get('cat-icon-add') === undefined) {
    customElements.define('cat-icon-add', BlocksIconAdd);
}
